export default __webpack_public_path__ + "static/media/ford.a1c8e40c.png";